export const firebaseConfig = {
  apiKey: "AIzaSyBfO3WIZ90fZ4-T-Yypua0PswxfkWiyd2Y",
  authDomain: "jewish-meditation.firebaseapp.com",
  projectId: "jewish-meditation",
  storageBucket: "jewish-meditation.appspot.com",
  messagingSenderId: "1030010135163",
  appId: "1:1030010135163:web:c99ecb689d7fb36f90f8de",
  measurementId: "G-Q76N97Z73K",
};

export const siteName = "אחד";
